
import React from 'react';
import { ArrowRight, ShieldCheck, Mail, Phone, MapPin } from 'lucide-react';
import { Page } from '../App';
import Logo from './Logo';

interface FooterProps {
  onNavigate: (page: Page) => void;
}

const Footer: React.FC<FooterProps> = ({ onNavigate }) => {
  return (
    <footer className="bg-slate-900 text-slate-400 py-24 border-t border-white/5">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 mb-20">
          <div className="space-y-8">
            <div className="flex items-center gap-3">
              <Logo className="h-20" />
            </div>
            <p className="text-sm leading-relaxed opacity-60">
              Karnataka's leading renewable energy provider. Specializing in sustainable solutions for residential and agricultural needs since 1984.
            </p>
            <div className="space-y-2 text-[10px] font-bold uppercase tracking-widest">
               <div className="flex items-center gap-2"><ShieldCheck size={14} className="text-green-500" /> GST: 29AAYCS3512J1ZQ</div>
               <div className="flex items-center gap-2"><ShieldCheck size={14} className="text-green-500" /> CIN: U74999KA2017PTC098948</div>
            </div>
          </div>

          <div>
            <h4 className="text-white font-bold uppercase tracking-widest text-xs mb-8">Navigation</h4>
            <ul className="space-y-5">
              {[
                { label: 'Home', value: 'home' },
                { label: 'Products', value: 'products' },
                { label: 'Pricing', value: 'pricing' },
                { label: 'About Us', value: 'about' },
                { label: 'Contact', value: 'contact' },
              ].map((link) => (
                <li key={link.value}>
                  <button 
                    onClick={() => onNavigate(link.value as Page)}
                    className="text-sm hover:text-green-500 transition-colors flex items-center gap-2 font-medium"
                  >
                    <ArrowRight size={14} className="opacity-30" />
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold uppercase tracking-widest text-xs mb-8">Get In Touch</h4>
            <ul className="space-y-6">
              <li className="flex gap-4">
                <MapPin size={18} className="text-green-600 shrink-0" />
                <span className="text-sm opacity-80 leading-relaxed">126/A, Ground Floor, Ullal Main Road, Bengaluru - 560056</span>
              </li>
              <li className="flex gap-4">
                <Phone size={18} className="text-green-600 shrink-0" />
                <span className="text-sm opacity-80">+91 98869 78555</span>
              </li>
              <li className="flex gap-4">
                <Mail size={18} className="text-green-600 shrink-0" />
                <span className="text-sm opacity-80">suryamitra.ceo@gmail.com</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold uppercase tracking-widest text-xs mb-8">Subsidy Portal</h4>
            <p className="text-sm mb-6 opacity-60">Apply for government incentives through our specialized portal support.</p>
            <button 
              onClick={() => onNavigate('contact')}
              className="w-full bg-white/5 hover:bg-white/10 text-white font-bold py-4 rounded-xl border border-white/10 transition-all text-xs uppercase tracking-widest"
            >
              Start Application
            </button>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-6 text-[10px] font-bold uppercase tracking-[0.2em] opacity-40">
          <div>© 2024 Sun-farms Green Energy Pvt Ltd. Bengaluru, India.</div>
          <div className="flex gap-8">
            <a href="#" className="hover:text-white">Privacy Policy</a>
            <a href="#" className="hover:text-white">Terms of Service</a>
            <a href="#" className="hover:text-white">Sitemap</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
